import PropTypes from 'prop-types';
import { disableHeroCarouselLiveRegion, enableHeroCarouselLiveRegion } from 'app/utilities/update-hero-carousel';
import React, { useEffect } from 'react';

const FullScreenDialog = React.forwardRef(({ children, extraClass, isActive, ...props }, ref) => {
    // Accessibility hack: turn off live region on hero-carousel when this dialog is active
    // NVDA keeps announcing changes on the hero carousel even if we set aria-modal="true"
    useEffect(() => {
        if (isActive === undefined) {
            return;
        }

        if (isActive) {
            disableHeroCarouselLiveRegion();
        } else {
            enableHeroCarouselLiveRegion();
        }

        // Ensure we clean up (enable the live region) in case this Dialog is yanked from the DOM
        return () => {
            enableHeroCarouselLiveRegion();
        };
    }, [isActive]);

    return (
        <div className={`full-screen-dialog ${extraClass}`}
            ref={ref}
            role="dialog"
            aria-modal="true"
            {...props}
        >
            {children}
        </div>
    );
});

FullScreenDialog.displayName = 'FullScreenDialog';
FullScreenDialog.defaultProps = {
    extraClass: ''
};

FullScreenDialog.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    extraClass: PropTypes.string,
    isActive: PropTypes.bool,
};

export default FullScreenDialog;
